// A4_Portrait width: 210mm, height: 297mm
const A4_LANDSCAPE: PAGE_SHAPE = { width: 1123, height: 793.7, unit: 'px' }
const A4_PORTRAIT: PAGE_SHAPE = { width: 793.7, height: 1122, unit: 'px' }

export { A4_LANDSCAPE, A4_PORTRAIT }

export interface PageXY {
  x: number
  y: number
}

export interface ReportFilters {
  name: string
  value: string
}

export interface ReportParameter {
  name: string
  type: string
  required: boolean
}

export type PAGE_SHAPE = { height: number; width: number; unit: string }
